import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react"
import PayPalApplePay from "../PayPalApplePay"
import PayPalCardFields from "../PayPalCardFields"
import PromoCodeSuccessPopUp from "../../../subscription/PromoCodeSuccessPopUp"
import secureLocalStorage from "react-secure-storage"
import useLoading from "../../../../hooks/useLoading"
import { CardSelector } from "../../../subscription"
import { PayPalButton } from "../PayPalButton"
import { SubscriptionContext } from "../../../subscription"
import { SubscriptionRequests } from "../../../../api/app.service"
import { useIntercom } from "react-use-intercom"
import { UserCtx } from "../../../../context/userContext"
import { useToast } from "../../../../hooks/useToast"

declare global {
  interface Window {
    paypal: any
  }
}

interface Props {
  appliedDiscount: {
    amount: number
    promo_code: string
  }
  isTermsAgreed: boolean
  setIsTermsAgreed: React.Dispatch<React.SetStateAction<boolean>>
  redirectUrl: string
  selectedPlanFromChild: any
  isIIN: boolean
}

export const PayPalSubscriptionPayNow: React.FC<Props> = ({
  appliedDiscount,
  isTermsAgreed,
  setIsTermsAgreed,
  redirectUrl,
  selectedPlanFromChild,
  isIIN,
}) => {
  const {
    paymentMethods,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    showCreatePayment,
  } = useContext(SubscriptionContext)
  const { user } = useContext(UserCtx)
  const { toast } = useToast()
  const { startLoading, stopLoading } = useLoading()
  const { shutdown } = useIntercom()

  const isCheckedRef = useRef(false)
  const user_id = parseInt(user.user_id)
  const zoee_subscription_id = selectedPlanFromChild?.zoee_subscription_id
  const promo = appliedDiscount
  const value = selectedPlanFromChild?.amount
  const promoRef = useRef(promo)
  const zoeeSubscriptionIdRef = useRef(zoee_subscription_id)
  const valueRef = useRef(value)
  const clientID = process.env.REACT_APP_PAYPAL_CLIENT_ID
  const merchantID = process.env.REACT_APP_PAYPAL_PAYER_ID
  const isSubx = true

  const [isChecked, setIsChecked] = useState(false)
  const [isSdkReady, setIsSdkReady] = useState(false)
  const [newSubscription, setNewSubscription] = useState<any>(null)
  const [upcomingSubscription, setUpcomingSubscription] = useState<any>(null)
  const [showPopup, setShowPopup] = useState(false)
  const [amountValue, setAmountValue] = useState(value)
  const [promoAmount, setPromoAmount] = useState(promo?.amount ?? 0)

  useEffect(() => {
    shutdown()
  }, [shutdown])

  useEffect(() => {
    zoeeSubscriptionIdRef.current = zoee_subscription_id
  }, [zoee_subscription_id])

  useEffect(() => {
    setAmountValue(value)
    valueRef.current = value
  }, [value])

  useEffect(() => {
    setPromoAmount(promo?.amount ?? 0)
    promoRef.current = promo
  }, [promo])

  useEffect(() => {
    if (process.env.REACT_APP_DEV_ENV === "false" && !window.LeadDyno) {
      window.LeadDyno = {
        recordConversion: (...args: any) => {},
      }
    }
  }, [])

  // Sets up the transaction when a payment button is clicked
  const createOrder = useCallback(
    (data: any, source: "paypal" | "card" | "apple_pay" | "google-pay") => {
      const promoCode = promoRef.current
      const subIdRef = zoeeSubscriptionIdRef.current
      const baseAmount = isIIN ? 743.65 : valueRef.current
      const discount = promoRef.current?.amount ?? 0
      let AmountValueRef: number | string

      AmountValueRef = Number(baseAmount.toFixed(2))

      const zoeeSubscriptionId = isIIN ? "1005003" : subIdRef

      return SubscriptionRequests.createSubscriptionOrder({
        user_id,
        source,
        subscription: {
          zoee_subscription_id: zoeeSubscriptionId,
          promo_details: promoCode,
          amount: {
            currency_code: "USD",
            value: AmountValueRef,
          },
          save_for_future: true,
        },
      })
        .then((res: any) => res.data)
        .then((order: any) => order.id)
    },
    []
  )

  // Finalize the transaction after payer approval
  const onApprove = useCallback(
    (data: any, source: "paypal" | "card" | "apple_pay" | "google-pay") => {
      const promoCode = promoRef.current
      const subIdRef = zoeeSubscriptionIdRef.current
      const baseAmount = isIIN ? 743.65 : valueRef.current
      const discount = promoRef.current?.amount ?? 0
      const zoeeSubscriptionId = isIIN ? "1005003" : subIdRef
      let AmountValueRef: number | string

      AmountValueRef = Number(baseAmount.toFixed(2))

      return SubscriptionRequests.completeSubscriptionOrder({
        user_id,
        source,
        subscription: {
          name: zoeeSubscriptionId,
          promo_details: promoCode,
          amount: {
            currency_code: "USD",
            value: AmountValueRef,
          },
        },
        order: data.orderID,
      })
        .then((res: any) => res.data)
        .then((orderData) => {
          toast.success(" 🎉Congrats! You have purchased a Subscription!")
          toast.success("Hang tight — redirecting you in a moment...")

          const rawUser = secureLocalStorage.getItem("user")
          const userObject =
            typeof rawUser === "string" ? JSON.parse(rawUser) : {}

          if (userObject) {
            userObject.isSubscribed = true
            secureLocalStorage.setItem("user", JSON.stringify(userObject))
          }

          const isDev = process.env.REACT_APP_DEV_ENV === "true"
          if (window.LeadDyno && !isDev) {
            window.LeadDyno.recordPurchase({
              saleAmount: AmountValueRef.toString(),
              email: user?.email,
            })
          }

          getSubscription()
        })
        .catch((error) => {
          toast.error(error.response.data.error_detail)
          console.error("error in approve:", error)
        })
    },
    []
  )

  const getSubscription = async () => {
    startLoading()
    await SubscriptionRequests.getActiveSubscriptionCoach({
      user_id: parseInt(user.user_id),
    })
      .then((data: any) => {
        if (Object.keys(data.active_subscription).length !== 0) {
          setNewSubscription(data.active_subscription)
          // Check promo code from the response data
          const promoCode = data.active_subscription.subscription_promo_code
          if (
            promoCode === "ZOEELIFEFIRST50" ||
            promoCode === "ZOEELIFEPOST50"
          ) {
            setShowPopup(true)
          } else {
            window.location.replace(redirectUrl)
          }
        } else {
          setNewSubscription(null)
        }
        if (Object.keys(data.upcoming_subscription).length !== 0) {
          setUpcomingSubscription(data.upcoming_subscription)
        } else {
          setUpcomingSubscription(null)
        }
      })
      .catch((ex) => {
        console.error(ex)
        toast.error(ex.response.data.message)
      })
      .finally(() => {
        stopLoading()
      })
  }

  useEffect(() => {
    setIsChecked(true)
  }, [isChecked])

  useEffect(() => {
    const loadPayPalSDK = () => {
      if (document.getElementById("paypal-sdk")) {
        console.log("PayPal SDK already loaded.")
        setIsSdkReady(true)
        return
      }

      const script = document.createElement("script")
      script.id = "paypal-sdk"
      script.src = `https://www.paypal.com/sdk/js?components=buttons,card-fields,applepay,googlepay&client-id=${clientID}&merchant-id=${merchantID}&currency=USD&intent=capture&disable-funding=paylater`
      script.async = true

      script.onload = () => {
        console.log("PayPal SDK loaded successfully.")
        setIsSdkReady(true)
      }

      script.onerror = (err) => {
        console.error("Failed to load PayPal SDK:", err)
      }

      document.body.appendChild(script)
    }

    loadPayPalSDK()
  }, [])

  if (!isSdkReady) {
    return <div>Loading PayPal SDK...</div>
  }

  return (
    <div className="justify-flex flex-col items-center justify-center">
      <PromoCodeSuccessPopUp
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        redirectUrl={redirectUrl}
        promoCode={newSubscription?.subscription_promo_code}
      />
      <PayPalButton createOrder={createOrder} onApprove={onApprove} />
      <PayPalApplePay
        createOrder={createOrder}
        onApprove={onApprove}
        isSdkReady={isSdkReady}
        subscriptionAmount={amountValue}
        subscriptionPromo={promoAmount}
      />
      <div className="flex items-center w-full mb-2 mt-2">
        <div className="flex-grow border-t border-gray-300"></div>
        <span className="mx-2 text-gray-500 text-graySlate">OR</span>
        <div className="flex-grow border-t border-gray-300"></div>
      </div>

      {paymentMethods ? (
        <>
          {showCreatePayment ? (
            <>
              <PayPalCardFields
                isCheckedRef={isCheckedRef}
                isChecked={isChecked}
                setIsChecked={setIsChecked}
                onApprove={onApprove}
                createOrder={createOrder}
                isTermsAgreed={isTermsAgreed}
                setIsTermsAgreed={setIsTermsAgreed}
                redirectUrl={redirectUrl}
                selectedPlanFromChild={selectedPlanFromChild}
                isSubx={isSubx}
                activeService=""
              />
              {}
            </>
          ) : (
            <CardSelector
              paymentMethods={paymentMethods}
              selectedPaymentMethod={selectedPaymentMethod}
              setSelectedPaymentMethod={setSelectedPaymentMethod}
              callback={() => {}}
            />
          )}
        </>
      ) : (
        <>
          <PayPalCardFields
            isCheckedRef={isCheckedRef}
            isChecked={isChecked}
            setIsChecked={setIsChecked}
            onApprove={onApprove}
            createOrder={createOrder}
            isTermsAgreed={isTermsAgreed}
            setIsTermsAgreed={setIsTermsAgreed}
            redirectUrl={redirectUrl}
            selectedPlanFromChild={selectedPlanFromChild}
            isSubx={isSubx}
            activeService=""
          />
          {}
        </>
      )}
    </div>
  )
}

export default PayPalSubscriptionPayNow
